import client from '../httpClient';

const commonGetHeaderNumberApi = async () => {
  const result = await client.get('/common/users/count');
  return result;
};

export default commonGetHeaderNumberApi;
